/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2022 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
    if($('.carousel-accolades')){
        $('.carousel-accolades').slick({
            centerMode: false,
            centerPadding: 0,
            slidesToShow: 1,
            infinite: true,
            variableWidth: true,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 1330,
                settings: {
                  slidesToShow: 5,
                },
              },
            ],
          });
    }

    // Bio accordion
    $('.doc-overview .doc-overview__button').click(function (e) {
        var $hiddenContent = $(this).prev('.dov-overview__hidden-content');
        $('.doc-overview .doc-overview__button').removeClass('js-accordion-open').text(dictionary.ReadBio);
        $('.doc-overview .dov-overview__hidden-content').slideUp();
    
        if ($(this).prev('.dov-overview__hidden-content').is(':hidden') == true) {
          $(this).addClass('js-accordion-open').text(dictionary.HideBio);
          $(this).prev('.dov-overview__hidden-content').slideDown();
        } else {
            $hiddenContent.slideUp(function() {
                $('html, body').animate({
                    scrollTop: $('.doc-overview').offset().top
                }, 500); // You can adjust the duration of the scroll animation
            });
        }
        e.preventDefault();
      });

    // Hide all bio text
    $('.doc-overview .dov-overview__hidden-content').hide();

    // Animation scrollspy
    const elements = document.querySelectorAll('.js-animate');
    const specificElementId = 'triggerCountUp';
    function callback(entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !entry.target.classList.contains('is-animated')) {
            entry.target.classList.add('is-animated');
    
            if (entry.target.id === specificElementId) {
              animateCSSCount();
            }
    
            observer.unobserve(entry.target);
          }
        });
      }
    
      const observer = new IntersectionObserver(callback, {
        threshold: 0.2
      });
    
      elements.forEach((el) => observer.observe(el));

    //Toggle for video
    const videoHolder = document.querySelector('.simple-cta-image__video-holder');
    const iframe = videoHolder != null ? videoHolder.querySelector('iframe') : null;
    const videoUrl = iframe != null ? iframe.getAttribute('data-video') || iframe.getAttribute('src') : null;
    if (videoHolder != null && iframe != null && videoUrl) {
        const playVideo = function () {
            if (videoHolder.classList.contains('is-active')) {
                return;
            }
            videoHolder.classList.add('is-active');
            iframe.src = videoUrl;

            const legacyHolder = document.querySelector('.video-holder');
            if (legacyHolder != null) {
                legacyHolder.style.display = 'block';
            }

            videoHolder.removeAttribute('role');
            videoHolder.removeAttribute('tabindex');
            videoHolder.removeAttribute('aria-label');
            iframe.setAttribute('tabindex', '0');
            iframe.focus();
        };

        const label = videoHolder.querySelector('.button-text');
        videoHolder.setAttribute('role', 'button');
        videoHolder.setAttribute('tabindex', '0');
        videoHolder.setAttribute('aria-label', label ? label.textContent.trim() : 'Play video');

        videoHolder.addEventListener('click', playVideo);

        videoHolder.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                playVideo();
            }
        });
    }
    function animateCSSCount() {
        const countUps = document.querySelectorAll('.stat-card-grid__count-up');
    
        countUps.forEach((el) => {
          if (el.dataset.animated === 'true') return;
          el.dataset.animated = 'true';
    
          const rawValue = (el.dataset.countTo || el.textContent.trim()).replace(/,/g, '');
          const target = parseFloat(rawValue) || 0; 
          const decimalPlaces = target.toString().includes('.') ? target.toString().split('.')[1].length : 0;
    
          const duration = 1750;
          const startTime = performance.now();
    
          function update(now) {
            const progress = Math.min((now - startTime) / duration, 1);
            const current = target * progress;
            el.style.setProperty('--count-value', current);
    
            const formatted = current.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            el.textContent = formatted;
    
            if (progress < 1) {
              requestAnimationFrame(update);
            } else {
              const finalFormatted = target.toLocaleString(undefined, {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
              });
              el.textContent = finalFormatted;
            }
          }
    
          requestAnimationFrame(update);
        });
      }

  //Zoom out image as scrolled
  function aimateImageZoom() {
      const images = document.querySelectorAll('.js-scale-image');
      const minScale = 1; // Minimum scale factor
      const maxScale = 1.125; // Maximum scale factor

      window.addEventListener('scroll', function() {
          const scrollPosition = window.scrollY;
          const scaleFactor = maxScale - (scrollPosition / 1000) * (maxScale - minScale);

          // Limit minimum scale to minScale
          images.forEach(image => {
              image.style.transform = `scale(${Math.max(scaleFactor, minScale)})`;
          });
      });
  }

}(jQuery));
